import { VisualizationPageProps } from '@/components/pages/analytics/utils/get-visualization-props';

export const isVisualizationPageProps = (obj: any): obj is VisualizationPageProps => obj && 'visualization' in obj;
